import React from 'react';
import { FormattedMessage } from 'react-intl';

import wrapIn from 'app/enhancers/wrapIn';
import S from 'app/features/success/components/Cards.styled';
import Heading from 'app/components/layout/Heading.styled';
import Series from 'app/features/success/seriesBlock/components/Series';
import SeeAll from 'app/features/success/seriesBlock/components/SeeAll';
import BlockWrapper from 'app/features/success/components/BlockWrapper';

const UI = () => (
  <article data-t="seriescards-block">
    <S.CardsHolder.Header>
      <Heading size="l" as="h2">
        <FormattedMessage id="success_series_cards_title" />
      </Heading>
      <SeeAll />
    </S.CardsHolder.Header>
    <Series />
  </article>
);

UI.displayName = 'SeriesBlock';

const SeriesBlock = wrapIn(BlockWrapper)(UI);

export default SeriesBlock;
